import { Record } from 'immutable';

export const AccountNode = Record({
  id: null,

  depth: 0,
  isLeaf: 0,
  displayLabel: '',
  displayOrder: 0,
  displayThemeBgColor: null,
  displayThemeColor: null,
  expandable: true,
  svgIconId: '',
  routeTo: null,

  account: null,
  allAccountIds: null,

  children: null,

  balance: 0,
  goalsBalance: 0,
  availableBalance: 0,

  currency: null,
  hide: false,
});
